export const drawerSidebarRoutes = ['/watch']
